<button (click)="submitEvent.emit()"
  class="transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-100 no-underline text-xs sm: font-medium py-2 px-3 bg-green rounded cursor-pointer flex outline-none">
  <span class="text-primary font-medium">
    <fa-icon [icon]="recommend ? icons.faHeart : icons.faHeartRegular" class="mr-2"></fa-icon>
  </span>
  <div>{{title}}</div>
</button>